import React from 'react';
import { CheckCircle, Clock, FileText } from 'lucide-react';

const SuccessStep = ({ resetForm, protocolNumber }) => {
  return (
    <div className="success-screen">
      <CheckCircle className="success-icon" size={64} color="#27ae60" />
      
      <h2 className="success-title">Αίτημα Υποβλήθηκε Επιτυχώς!</h2>
      
      {protocolNumber && (
        <div style={{
          background: '#e3f2fd',
          padding: '20px',
          borderRadius: '12px',
          border: '2px solid #2196f3',
          marginBottom: '25px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '14px', color: '#1976d2', marginBottom: '8px', fontWeight: '600' }}>
            Αριθμός Πρωτοκόλλου
          </div>
          <div style={{ 
            fontSize: '32px', 
            fontWeight: 'bold', 
            color: '#1976d2',
            letterSpacing: '2px',
            fontFamily: 'monospace'
          }}>
            {protocolNumber}
          </div>
          <div style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
            Κρατήστε αυτόν τον αριθμό για μελλοντική αναφορά
          </div>
        </div>
      )}
      
      <p className="success-message">
        Το αίτημά σας έχει καταχωρηθεί στο σύστημα και θα επεξεργαστεί από την ομάδα μας.
        {protocolNumber && ` Το πρωτόκολλο σας είναι: ${protocolNumber}.`}
         Κρατήστε τον αριθμό πρωτοκόλλου για μελλοντική αναφορά.
      </p>

      <div style={{ 
        background: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        marginBottom: '30px'
      }}>
        <h4 style={{ marginBottom: '15px', color: '#2c3e50' }}>Τι ακολουθεί:</h4>
        
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <Clock size={20} color="#f39c12" style={{ marginRight: '10px' }} />
          <span>Η επεξεργασία θα ολοκληρωθεί εντός ολίγων ημερών</span>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FileText size={20} color="#27ae60" style={{ marginRight: '10px' }} />
          <span>Θα λάβετε το έγγραφο με email όταν είναι έτοιμο</span>
        </div>
      </div>

      <div style={{ 
        background: '#e3f2fd', 
        padding: '15px', 
        borderRadius: '8px',
        border: '1px solid #2196f3',
        marginBottom: '30px'
      }}>
        <h4 style={{ marginBottom: '10px', color: '#1976d2' }}>Σημαντικές Πληροφορίες:</h4>
        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px' }}>
          <li>Κρατήστε τον αριθμό πρωτοκόλλου για μελλοντική αναφορά</li>
          <li>Για ερωτήσεις, επικοινωνήστε με τη Γραμματεία στο 2310 381013</li>
          <li>Το σύστημα λειτουργεί 24/7 για υποβολή αιτημάτων</li>
        </ul>
      </div>

      <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
        <button
          className="btn btn-primary"
          onClick={resetForm}
        >
          Νέα Αίτηση
        </button>
        
        <button
          className="btn btn-secondary"
          onClick={() => window.print()}
        >
          Εκτύπωση Σελίδας
        </button>
      </div>

      <div style={{ 
        marginTop: '30px', 
        padding: '15px', 
        background: '#f8f9fa',
        borderRadius: '8px',
        fontSize: '12px',
        color: '#666'
      }}>
        <strong>424 Γενικό Στρατιωτικό Νοσοκομείο Εκπαιδεύσεως</strong><br />
        Αυτόματο σύστημα αιτημάτων χορήγησης ιατρικών εγγράφων<br />
        {protocolNumber && (
          <>
            <strong>Πρωτόκολλο:</strong> {protocolNumber}<br />
          </>
        )}
        Ημερομηνία: {new Date().toLocaleDateString('el-GR')} | Ώρα: {new Date().toLocaleTimeString('el-GR')}
      </div>
    </div>
  );
};

export default SuccessStep;











